const themes = {
  bohren: {
    backgroundColor: '#6EB2C5',
    foregroundColor: '#556296',
    screensaverForegroundColor: '#556296',
    buttonpageForegroundColor: '#556296',
    buttonColor: '#6EB2C5',
    textColor: '#FFFFFF',
  },
  tragen: {
    backgroundColor: '#722a40ff',
    foregroundColor: '#a4576dff',
    screensaverForegroundColor: '#a4576dff',
    buttonpageForegroundColor: '#a4576dff',
    buttonColor: '#722a40ff',
    textColor: '#FFFFFF',
  },
  ziehen: {
    backgroundColor: '#D9AC40',
    foregroundColor: '#F3D97B',
    screensaverForegroundColor: '#F3D97B',
    buttonpageForegroundColor: '#F3D97B',
    buttonColor: '#D9AC40',
    textColor: '#FFFFFF',
  },
  quiz: {
    backgroundColor: '#62a66b',
    foregroundColor: 'rgba(142, 183, 147, 1)',
    screensaverForegroundColor: 'rgba(142, 183, 147, 1)',
    buttonColor: '#62a66b',
    textColor: '#FFFFFF',
  },
};

export default themes;
